import { TypeformForm } from 'generated/graphql';
import { IntegrationFormType } from 'v2/core/entities/integrations';

export const mapEdgeDataToForms = (
  forms: TypeformForm[],
): IntegrationFormType[] => {
  return forms.map((form) => ({
    title: form.title,
    id: form.id,
  }));
};
